import equals from 'ramda/src/equals'
import { CAMPAIGN_DASHBOARD_SLIDEOUT_TRAY } from 'root/src/shared/descriptions/modules/moduleIds'
import { dropEventStatusEnum } from 'root/src/shared/constants/dropEvent'
import { appStoreLenses } from 'root/src/client/logic/app/lenses'
import { CAMPAIGN_DASHBOARD_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import moment from 'moment-mini'

const { viewDropEvents } = appStoreLenses

const isLiveDropEvent = (dropEvent) => {
	const { isLive, subscriptionStatus, isUserActivated } = dropEvent
	return (
		isLive
		&& equals(subscriptionStatus, dropEventStatusEnum.ACTIVE)
		&& isUserActivated
	)
}

export default {
	[CAMPAIGN_DASHBOARD_SLIDEOUT_TRAY]: {
		moduleType: 'slideoutTray',
		trayType: 'list',
		getTrayData: (state) => {
			const dropEvents = viewDropEvents(state) || []
			// Sorts by live date and active state
			return [...dropEvents].sort((a, b) => {
				const [isActiveA, isActiveB] = [isLiveDropEvent(a), isLiveDropEvent(b)]
				if (!isActiveA && !isActiveB) {
					return -1
				}

				if (isActiveA) {
					if (isActiveB) {
						return moment(a.liveDate).isSameOrAfter(b.liveDate) ? -1 : 1
					}
					return -1
				}
				return 1
			})
		},
		displayProp: 'campaignName',
		// infoText: ({ data }) => moment(data.liveDate).format('MM/YY'),
		infoText: ({ data }) => moment(data.liveDate).format('MM/YY'),
		getLinkProps: ({ data }) => {
			const { mnemonicId } = data
			return { routeId: CAMPAIGN_DASHBOARD_ROUTE_ID, routeParams: { recordId: mnemonicId } }
		},
		indicatorData: {
			type: 'circle',
			indicatorFn: isLiveDropEvent,
		},
		isChosen: ({ data, currentRouteObj }) => {
			const { routeParams } = currentRouteObj
			const { mnemonicId } = data
			return equals(routeParams?.recordId, mnemonicId)
		},
	},
}
